<script lang="ts">
  export let id = "company-name"; // if using more than one honeypot field, ensure each has a unique id
  export let name = "company-name";
  export let placeholder = "Company name";

  export const isFilled = () => value! != "";
  export const content = () => value;

  let value = "";

  /**
   * A honeypot is a trap field designed to detect and prevent automated form submissions by bots/spammers
   * This component is used as a security measure to detect and silently reject bots.
   * See {@link https://linear.app/outverse/issue/ENG-2101/add-honeypot-to-forms} for more information.
   *
   */
</script>

<div aria-hidden="true" class="input-style">
  <!-- backup label in case form is read by screen reader -->
  <label for={id} class="sr-only">If you are human, leave this field blank</label>

  <!-- tab index -1 prevents the field from being accessed via the keyboard -->
  <!-- svelte-ignore a11y-autocomplete-valid -->
  <input {id} {name} {placeholder} bind:value type="text" tabindex="-1" autocomplete="false" />
</div>

<style lang="postcss">
  .input-style {
    /* clip the element to a rectangle with zero dimensions (making it invisible) */
    clip: rect(0 0 0 0);

    /* set the height + width to 1px to minimize visibility - fallback for clip property */
    height: 1px;
    width: 1px;

    /*  Negative margin to pull the element out of the normal document flow */
    margin: -1px;

    /* Hide any content that overflows the element's box */
    overflow: hidden;

    /* no padding to ensure the element stays as small as possible */
    padding: 0;

    /* no border to avoid any visible outline or structure */
    border: 0;

    /* position behind all other elements */
    z-index: -9999;
  }
</style>
